// §11.11 / §9.1 — the Recycle Bin as a first-class app.
//
// It has been a *place* since M4 (Explorer's Trash view) and an icon since M6 (the Dock's, D-145);
// this is the app both of those were standing in for. It registers no file types: nothing opens
// "in the Recycle Bin", you go to it.
import { createRoot, type Root } from 'react-dom/client';
import type { InProcessApp, RecycleBinShellAccess } from '@hangar/shared';
import { RecycleBin } from './RecycleBin';
import './recycle-bin.css';

const roots = new WeakMap<HTMLElement, Root>();

export function createRecycleBinApp(access: RecycleBinShellAccess): InProcessApp {
  return {
    id: 'recycle-bin',
    name: 'Recycle Bin',
    icon: { glyph: 'trash-2', hue: 100 },
    keywords: ['trash', 'deleted', 'bin', 'restore', 'undelete'],
    window: { width: 820, height: 520, minWidth: 420, minHeight: 260, multiWindow: false },

    mount(container, _api) {
      const root = createRoot(container);
      roots.set(container, root);
      root.render(<RecycleBin access={access} />);
    },

    unmount(container) {
      const root = roots.get(container);
      roots.delete(container);
      root?.unmount();
    },
  };
}
